import React, { useEffect, useState } from 'react';
import { API_BASE_URL } from '../utils/apiConfig';
import { useUserContext } from '../context/user_context';
import PayablesList from '../components/PayablesList';
//import './Receivable.css';

const Payables = () => {
    const { user } = useUserContext();
    const [isLoading, setIsLoading] = useState(false);
    const [payables, setPayables] = useState(null);
    const [filteredCount, setFilteredCount] = useState(0);
    const [region, setRegion] = useState(null);

    const fetchPayables = async () => {
        try {
            setIsLoading(true);
            const apiUrl = `${API_BASE_URL}/payables`;
            const response = await fetch(apiUrl, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${user?.results?.token}`,
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error('Failed to fetch payables');
            }

            const fetchedPayables = await response.json();
            // Log the data from the API
            setPayables(fetchedPayables.results.payablesResult); // Update the state
        } catch (error) {
            console.error('Error fetching payables:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const loadAreasOfBusiness = async () => {
        try {
            setIsLoading(true);
            const apiUrl = `${API_BASE_URL}/aob/all`;

            const response = await fetch(apiUrl, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${user?.results?.token}`,
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error('Failed to fetch areas of business');
            }

            const data = await response.json();
            setRegion(data?.results);
           
        } catch (error) {
            console.error('Error fetching areas of business:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (user) {
            fetchPayables(); // Fetch payables when the user is available
            loadAreasOfBusiness(); // Load areas of business
        }
    }, [user]); // Dependency on user to ensure the fetch happens after user is set

    // Log whenever `payables` changes
    useEffect(() => {
        console.log('Updated Payables State:', payables);
    }, [payables]);

    const refreshPayables = () => {
        fetchPayables(); // Refresh the payables list
    };

    const handleFilteredCount = (count) => {
        setFilteredCount(count); // Update the count of filtered items
    };

    const mainContainerStyle = {
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    };

    return (
        <div style={mainContainerStyle}>
            {payables && payables.length > 0 ? (
                <section className="receivablecontainer">
                    <h3>Payables List ({filteredCount})</h3>
                    {isLoading ? (
                        <p>Loading...</p>
                    ) : (
                        <PayablesList
                            payables={payables}
                            region={region}
                            onFilteredCount={handleFilteredCount}
                            refreshPayables={refreshPayables}
                        />
                    )}
                </section>
            ) : (
                <section className="receivablecontainer">
                    <h3>No Payables Data to Show</h3>
                </section>
            )}
        </div>
    );
};

export default Payables;
